import React, { useState } from "react";

const useGetBankAccounts = () => {
    const [data, setData] = useState<{ Id: string; Name: string }[]>([
        { Id: "1", Name: "Bank Account 1" },
        { Id: "2", Name: "Bank Account 2" },
        { Id: "3", Name: "Bank Account 3" },
    ]);

    return {
        data,
        isFetching: false,
        error: null,
    };
};

export default useGetBankAccounts;
